import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface DesktopOverlayPanelProps {
  children: ReactNode;
  className?: string;
}

export function DesktopOverlayPanel({ children, className }: DesktopOverlayPanelProps) {
  return (
    <div
      className={cn(
        'absolute -inset-2 md:-inset-10 z-50 bg-[#0E0E0E] border-l border-white/[0.04] flex flex-col overflow-hidden',
        className,
      )}
    >
      {children}
    </div>
  );
}
